<template>
  <layout-simple title="Datenschutzerklärung">
    <v-container class="padded">
      <v-card flat>
        <h1 id="datenschutzinformationen">Datenschutzinformationen</h1>
        <h2 id="geltungsbereich-und-verantwortlichkeit">Geltungsbereich und Verantwortlichkeit</h2>
        <p>
          Die mint software GmbH, Carl-Fischer-Str. 2, 49084 Osnabrück, E-Mail: info@mmmint.ai
          („<strong>Anbieter</strong>&quot;, „<strong>wir</strong>&quot; oder „<strong>uns</strong>&quot; genannt)
          betreibt die Website <em>schadensmeldung.digital</em> („<strong>Website</strong>“) und hat eine Web-App mit
          dem Namen <strong>schadensmeldung.digital</strong> entwickelt („<strong>Plattform</strong>”) (zusammen im
          Folgenden <strong>„digitale Angebote“</strong> genannt).
        </p>
        <p>
          Diese Datenschutzinformationen gelten für die Verarbeitung personenbezogener Daten bei dem Besuch und der
          Nutzung unserer digitalen Angebote als registrierter Nutzer mit Nutzerkonto (siehe hierzu insbesondere Ziffer
          3) ebenso wie für die Nutzung der digitalen Angebote als Gastnutzer. Die Datenschutzinformationen gelten nicht
          für Websiten oder Plattformen anderer Anbieter, auf die wir im Rahmen unserer digitalen Angebote verweisen.
          Bitte informiere dich auch bei dem jeweiligen Anbieter über den Umgang mit deinen Daten, falls du von unseren
          digitalen Angeboten auf andere Websiten oder Plattformen weitergeleitet wirst.
        </p>
        <p>
          Neben den digitalen Angeboten stellt der Anbieter einigen seiner gewerblichen Kunden ein Tool zur Kontrolle
          von Dokumenten („<strong>App</strong>“) zur Verfügung. Der gewerbliche Kunde des Anbieters stellt im Rahmen
          der Nutzung der App Daten – teilweise auch personenbezogene Daten seiner Endkunden – zur Verfügung, die der
          Anbieter dann als Auftragsverarbeiter i.S.d Art. 28 DS-GVO verarbeitet. Datenschutzrechtlicher
          Verantwortlicher für diese Endkundendaten ist im Rahmen der Nutzung der App der gewerbliche Kunde des
          Anbieters, sodass diese Datenschutzerklärung für diese Verarbeitungsvorgänge von Endkundendaten nicht
          anwendbar ist.
        </p>
        <p>
          Personenbezogene Daten sind nach Art. 4 Nr. 1 DS-GVO alle Informationen, die sich auf eine identifizierte oder
          identifizierbare Person beziehen („<strong>betroffene Person</strong>“). Hierunter fallen z. B. persönliche
          Angaben wie Name, Anschrift, E-Mail-Adresse und Telefonnummer, aber auch weitergehende Informationen, wie z.
          B. Nachrichten, die du uns schickst, dein Nutzerverhalten oder die Daten, die du im Rahmen der Nutzung
          eingibst. Die Erklärung für alle weiteren Begrifflichkeiten findest du in den Begriffsbestimmungen des Art. 4
          DS-GVO.
        </p>
        <p><strong>Verantwortlicher im Sinne des Art. 4 Nr. 7 DS-GVO ist:</strong></p>
        <p>mint software GmbH<br />Carl-Fischer-Str. 2<br />49084 Osnabrück<br />info@mmmint.ai</p>
        <p>Inhaltlich Verantwortlicher gem. § 18 Abs. 2 MStV: Maximilian Stein (Anschrift s.o.)</p>
        <p>
          Wir möchten dich mit diesen Datenschutzhinweisen über unsere Verarbeitungsvorgänge informieren und zugleich
          den gesetzlichen Pflichten, insbesondere aus der EU-Datenschutz-Grundverordnung (DS-GVO), nachkommen.
        </p>
        <h2 id="welche-personenbezogenen-daten-erfassen-wir-">Welche personenbezogenen Daten erfassen wir?</h2>
        <p>
          Bei der Benutzung unserer digitalen Angebote erheben wir verschiedene Kategorien personenbezogener Daten zu
          unterschiedlichen Zwecken. Wir möchten diese Datenverarbeitungsvorgänge im Folgenden so übersichtlich wie
          möglich für dich darstellen.
        </p>
        <h3 id="besuch-unserer-website-logfiles-">Besuch unserer Website (Logfiles)</h3>
        <p>
          Wenn du unsere digitalen Angebote besuchst, erfassen wir automatisch jeden Zugriff in einer Protokolldatei,
          die dein Browser an uns übermittelt. Dabei werden folgende Daten von uns gespeichert
          („<strong>Logfiles</strong>“):
        </p>
        <ul>
          <li>Datum, Uhrzeit, Ort und Land des Abrufs unserer Website (bzw. der Serveranfrage)</li>
          <li>Betriebssystem, Browsertyp, Browserversion und Anonymisierte IP-Adresse des Endgeräts,</li>
          <li>Internet-Service-Provider,</li>
          <li>Website, die zuvor besucht wurde (Referrer URL),</li>
          <li>Übertragene Datenmenge.</li>
        </ul>
        <p>
          Die Verarbeitung dieser Informationen ist technisch notwendig, um unsere digitalen Angebote ordnungsgemäß
          anzuzeigen und die Stabilität und Sicherheit zu gewährleisten. Die Informationen werden ausschließlich zu den
          vorgenannten Zwecken verarbeitet. Eine weitere Auswertung der Nutzerdaten findet nicht statt. Die Daten werden
          gelöscht, sobald sie für die Erreichung des Zwecks ihrer Erhebung nicht mehr erforderlich sind.
          Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DS-GVO.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt durch den Host unserer Website: Der Host agiert als Auftragsverarbeiter
          und wir haben einen entsprechenden Vertrag zur Auftragsdatenverarbeitung mit ihm geschlossen.
        </p>
        <p>Die Verarbeitung dieser Daten erfolgt durch die Hosts unserer Website:</p>
        <p>
          <strong>Fastly Inc</strong>., 475 Brannan St. 300, San Francisco, CA 94107,<br /><strong>GitHub Inc.</strong>,
          88 Colin P. Kelly Jr. St., San Francisco, CA 94107, USA und<br /><strong>Microsoft Corporation</strong>,One
          Microsoft Way, Redmond, WA 98052-6399 (USA) („<strong>Microsoft</strong>“) (nachfolgend gemeinsam
          <strong>“Hosts”</strong> genannt).
        </p>
        <p>
          Die Hosts agieren als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag zur
          Auftragsdatenverarbeitung mit ihnen geschlossen.
        </p>
        <p>
          Rechtsgrundlage für den Einsatz unserer Hosts ist unser berechtigtes Interesse, an einem sicheren und
          funktionierenden Betrieb unserer Website, Art. 6 Abs. 1 S. 1 lit. f DS-GVO.
        </p>
        <p>
          Teilweise werden unsere Hosts die auf unserer Website erfassten Daten (die nachfolgend dargestellt werden) in
          die USA übertragen und dort verarbeiten. Unsere Hosts haben sich als sichere Datenempfänger, die die
          Datenschutzgrundsätze des Data Privacy Framework berücksichtigen, zertifiziert. Bei einer Übertragung von
          Daten in die USA durch unsere Hosts wird also ein Datenschutzstandard gewahrt, der dem der DS-GVO entspricht.
        </p>
        <p>
          Weitere Informationen zur Datenverarbeitung durch unseren Host Fastly Inc. findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://www.fastly.com/de/privacy">hier</a>, durch
          den Host GitHub Inc.
          <a
            href="https://docs.github.com/de/pages/getting-started-with-github-pages/about-github-pages#data-collection"
            >hier</a
          >
          und für die Datenverarbeitung durch den Host Microsoft findest du weitere Informationen
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://azure.microsoft.com/de-de/explore/trusted-cloud/privacy"
            >hier</a
          >
          und für den Dienst Microsoft Application Insights
          <a
            href="https://learn.microsoft.com/de-de/azure/azure-monitor/app/app-insights-overview#how-does-application-insights-handle-data-collection-retention-storage-and-privacy"
            >hier</a
          >.
        </p>
        <h3 id="-besuch-unserer-digitalen-angebote-cookies">(Besuch unserer digitalen Angebote) Cookies</h3>
        <p>
          Wenn du unsere digitalen Angebote besuchst und nutzt, setzten wir gegebenenfalls Cookies ein. Cookies sind
          kleine Textdateien, die von unserem Webserver an den Browser deines Endgeräts versandt und auf diesem
          gespeichert werden. Cookies helfen unter vielen Aspekten, deinen Besuch auf unseren digitalen Angeboten
          einfacher, angenehmer und sicherer zu gestalten. Unsere digitalen Angebote nutzen folgende Arten von Cookies:
        </p>
        <p>
          <strong>Notwendige Cookies:</strong> Notwendige Cookies sind Cookies, die für die Nutzung unserer digitalen
          Angebote und ihrer jeweils grundlegenden Funktionen erforderlich sind. Ohne diese Cookies funktionieren unsere
          digitalen Angebote nicht oder nicht richtig; diese Cookies können daher nicht abgewählt werden.
          Rechtsgrundlage dieser Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DS-GVO. Diese Cookies werden grundsätzlich
          nach Ende deines Besuchs, spätestens bei Schließen der digitalen Angebote gelöscht.
        </p>
        <p>
          <strong>Optionale Cookies:</strong> Optionale Cookies sind Cookies, die es beispielsweise ermöglichen, den
          Datenverkehr, das Nutzungsverhalten und die technische Funktionalität unserer digitalen Angebote zu
          analysieren, um die Qualität und den Nutzungskomfort der digitalen Angebote zu optimieren (Tracking- und
          Performance-Cookies), die persönliche Einstellungen speichern, damit diese bei dem nächsten Besuch nicht
          erneut eingegeben werden müssen (Funktionale Cookies) oder die bestimmte Informationen zum Nutzungsverhalten
          auf unserer Seite mit solchen Informationen anderer Anbieter kombinieren, um personalisierte Werbeangebote
          machen zu können (Marketing Cookies).
        </p>
        <p>
          Jeder Einsatz von Optionalen Cookies stellt eine Datenverarbeitung dar, die nur mit deiner ausdrücklichen und
          aktiven Einwilligung über unseren Cookie-Banner erlaubt ist und jederzeit über diesen verwaltet und widerrufen
          werden kann. Rechtsgrundlage ist dann Art. 6 Abs. 1 S. 1 lit. a DS-GVO.
        </p>
        <p>
          Der Einsatz von Optionalen Cookies und anderen Analyse- und Marketingtechnologien wird in den folgenden
          Abschnitten weiter erläutert.
        </p>
        <h3 id="google-analytics">Google Analytics</h3>
        <p>
          Wir verwenden in unseren digitalen Angeboten Google Analytics, einen Webtracking-Dienst von Google Inc.,
          Mountain View, USA, im Europäischen Wirtschaftsraum (EWR) und der Schweiz werden Google-Dienste angeboten von
          der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland („<strong>Google</strong>“).
        </p>
        <p>
          Wir nutzen Google Analytics, um das Nutzerverhalten besser zu verstehen und unsere Inhalte sowie
          Dienstleistungen kontinuierlich zu verbessern. Google Analytics ermöglicht es uns, Berichte über Aktivitäten
          in unseren digitalen Angeboten zu erstellen und so unsere Online-Präsenz zu optimieren. Dabei werden
          verschiedene Daten erfasst, die uns helfen, die Interaktionen der Besucher unserer digitalen Angebote zu
          analysieren.
        </p>
        <p>
          Im Rahmen der Nutzung von Google Analytics erhebt und verarbeitet Google deine IP-Adresse, Informationen über
          das verwendete Endgerät (z. B. Gerätetyp, Betriebssystem, Browsertyp), Informationen zu deinem Surfverhalten
          (z. B. besuchte Seiten, Verweildauer, Klickverhalten), Standortdaten und eindeutige Kennungen, wie Cookie-IDs
          oder Google Analytics-IDs. Zu deinem Schutz nutzen wir aber natürlich die Anonymisierungsfunktion („IP
          Masking“), d.h. dass Google innerhalb der EU/des EWR die IP-Adressen um das letzte Oktett kürzt. Diese Daten
          werden verwendet, um Reports über die Aktivitäten in unseren digitalen Angeboten zu erstellen und uns eine
          detaillierte Analyse des Nutzerverhaltens zu ermöglichen.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Google geschlossen. Die
          durch das Cookie erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine Benutzung
          dieser digitalen Angebote werden teilweise an einen Server von Google in den USA übertragen und dort
          verarbeitet. Google hat sich als sicherer Datenempfänger, der die Datenschutzgrundsätze des Data Privacy
          Framework berücksichtigt, zertifiziert. Bei einer Übertragung von Daten in die USA durch Google wird also ein
          Datenschutzstandard gewahrt, der dem der DS-GVO entspricht. Wir haben zudem sog. Standardvertragsklauseln mit
          Google vereinbart, deren Zweck die Einhaltung eines angemessenen Datenschutzniveaus im Drittland ist.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von Google Analytics und der damit
          verbundenen Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst. Den Widerruf kannst du auch über das
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://tools.google.com/dlpage/gaoptout?hl=de/"
            >Browser-Add-on von Google</a
          >
          durchführen.
        </p>
        <p>
          Nähere Informationen zum Leistungsumfang von Google Analytics erhältst du
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://marketingplatform.google.com/about/analytics/terms/de/"
            >hier</a
          >. Informationen zur Datenverarbeitung bei Nutzung von Google Analytics stellt Google
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://support.google.com/analytics/answer/6004245?hl=de/"
            >hier</a
          >
          bereit. Generelle Hinweise zur Datenverarbeitung erhältst du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="http://www.google.de/intl/de/policies/privacy/"
            >Datenschutzerklärung</a
          >
          von Google.
        </p>
        <h3 id="google-ads-inkl-erweiterter-conversions">Google Ads inkl. Erweiterter Conversions</h3>
        <p>
          Wir verwenden das Online-Werbeprogramm Google Ads und die Funktionen der Erweiterten Conversions, Diensten von
          Google.
        </p>
        <p>
          Wir nutzen Google Ads, um auf Drittseiten im Internet auf unsere Angebote aufmerksam zu machen. Wenn du unsere
          digitalen Angebote besuchst, können durch Google Ads Anzeigen auf den von dir besuchten Seiten der digitalen
          Angebote ausgespielt werden. Google Ads ermöglicht uns, unsere Werbeanzeigen gezielt an Personen auszuspielen,
          die bereits Interesse an unseren digitalen Angeboten gezeigt haben. Durch den Einsatz von Google Ads können
          wir unsere Werbemaßnahmen effektiver gestalten und deine Nutzererfahrung verbessern. Im Rahmen der Nutzung von
          Google Ads erhebt und verarbeitet Google unter anderem deine IP-Adresse, Informationen über dein verwendetes
          Endgerät (z. B. Gerätetyp, Betriebssystem, Browsertyp), Angaben zu deinem Surfverhalten (z. B. besuchte
          Webseiten, Interaktionen mit Werbeanzeigen), Standortdaten und eindeutige Kennungen, wie Cookie-IDs oder
          Google Ads-IDs.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Google geschlossen. Die
          durch das/die Cookie/s erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine
          Benutzung dieser digitalen Angebote werden in der Regel an einen Server von Google in den USA übertragen und
          dort verarbeitet. Für die Einbindung von Google Ads verweisen wir auf die Zertifizierung von Google als
          sicherer Datenempfänger (s. Ziffer 2.3).
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast.
        </p>
        <p>
          Du kannst deine Einwilligung zur Verwendung von Google Ads und der damit verbundenen Datenerhebung jederzeit
          mit Wirkung für die Zukunft widerrufen, ohne dass davon die Zulässigkeit der Verarbeitung bis zum Widerruf
          berührt wird. Dies kannst du tun, indem du deine Cookie-Einstellungen auf unserer Website anpasst oder über
          die Google Ads-Einstellungen die Personalisierung der Werbung deaktivierst.
        </p>
        <p>
          Informationen zur Datenverarbeitung von Google bei Nutzung von Google Ads stellt Google
          <a
            href="https://support.google.com/google-ads/topic/11337105?hl=de&amp;ref_topic=10286612&amp;sjid=11937524379447575685-EU"
            >hier</a
          >
          bereit. Generelle Hinweise zur Datenverarbeitung durch Google erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://policies.google.com/privacy?hl=de&amp;gl=de"
            >Datenschutzerklärung</a
          >
          von Google.
        </p>
        <p>Mehr Informationen zu der Funktionsweise der Erweiterten Conversions findest du</p>
        <p>
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://support.google.com/google-ads/answer/9888656?hl=de"
            >hier</a
          >.
        </p>
        <h3 id="google-maps">Google Maps</h3>
        <p>Wir verwenden Google Maps, einen Online-Kartendienst von Google.</p>
        <p>
          Zweck unserer Nutzung dieses Tools ist eine nutzerfreundliche Darstellung geografischer Informationen,
          insbesondere zur Standortbestimmung und Adresssuche.
        </p>
        <p>
          Wenn du ein digitales Angebot aufrufst, das Google Maps enthält und du der Nutzung optionaler Cookies
          zugestimmt hast, baut dein Browser eine Verbindung mit den Servern von Google zur Einbindung des Karteninhalts
          auf. Informationen über deine Benutzung unserer digitalen Angebote, einschließlich deiner IP-Adresse und im
          Rahmen der Routenplanerfunktion eingegebene Adressen, werden hierbei an Google übermittelt.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Google geschlossen. Die
          durch das/die Cookie/s erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine
          Benutzung dieser digitalen Angebote werden in der Regel an einen Server von Google in den USA übertragen und
          dort verarbeitet. Für die Einbindung von Google Maps verweisen wir auf die Zertifizierung von Google als
          sicherer Datenempfänger (s. Ziffer 2.3).
        </p>
        <p>
          Rechtsgrundlage für die Erhebung und weitere Verarbeitung der Informationen ist die von dir erteilte
          Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DS-GVO). Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne
          dass davon die Zulässigkeit der Verarbeitung bis zum Widerruf berührt wird.
        </p>
        <p>
          Informationen zur Datenverarbeitung bei der Nutzung von Google Maps stellt Google unter diesem
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://policies.google.com/privacy?hl=de&amp;gl=de"
            >Link</a
          >
          bereit.
        </p>
        <h3 id="google-genai">Google GenAI</h3>
        <p>
          In unseren digitalen Angeboten verwenden wir den KI-gestützten Text- und Bildverarbeitungsdienst GenAI von
          Google. Diensteanbieter ist Google Inc., Mountain View, USA, Im Europäischen Wirtschaftsraum (EWR) und der
          Schweiz werden Google-Dienste angeboten von der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
          Irland („Google“).
        </p>
        <p>
          Wir nutzen GenAI zur regelbasierten Prüfung und Optimierung der durch den Auftraggeber übermittelten Dokumente
          und Bilder. Dabei werden die übermittelten Daten (z.B. hochgeladene Dokumente, wie Rechnungen und
          Kostenvoranschläge und selbst festgelegte Regeln zur Prüfung) zusammen mit unsererseits festgelegten Regeln
          und Prüfparametern zur Analyse an GenAI weitergeleitet zum Zweck der automatisierten inhaltlichen Auswertung
          und Prüfung.
        </p>
        <p>
          Hierzu erhebt und verarbeitet Google ggf. auch deine personenbezogenen Daten wie deinen Namen, deine Adresse
          oder Vertragsinhalte. Du kannst die Daten vor der Übermittlung eigenverantwortlich anonymisieren oder
          entfernen, sofern keine Prüfung dieser Informationen notwendig ist.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag i. S. d. Art. 28 DS-GVO mit
          Google geschlossen. Die in diesem Rahmen erhobenen und verarbeiteten Daten werden in der Regel an einen Server
          von Google Europa übertragen und dort verarbeitet. Falls es dennoch zu einer Übertragung von Daten in die USA
          kommen sollte, verweisen wir auf die Zertifizierung von Google als sicherer Datenempfänger auf Ziffer 2.3.
        </p>
        <p>
          Nähere Informationen zum Leistungsumfang von GenAI sind
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://cloud.google.com/products/ai">hier</a>
          verfügbar und Informationen zum Datenschutz findest du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://policies.google.com/privacy?hl=de&amp;gl=at"
            >Datenschutzerklärung</a
          >
          von Google.
        </p>
        <h3 id="youtube">YouTube</h3>
        <p>Wir verwenden in unseren digitalen Angeboten YouTube, eine Online-Videoplattform von Google.</p>
        <p>Zweck unserer Nutzung dieses Tools ist es, dir Videos von Produkten zu zeigen.</p>
        <p>
          Wenn du eine Seite unserer digitalen Angebote aufrufst, die YouTube enthält und du der Nutzung optionaler
          Cookies zugestimmt hast, baut dein Browser eine Verbindung mit den Servern von Google zur Einbindung des
          jeweiligen Videos auf. Informationen über deine Benutzung dieser digitalen Angebote einschließlich deiner
          IP-Adresse werden hierbei an Google übermittelt. YouTube agiert als Auftragsverarbeiter und wir haben einen
          entsprechenden Vertrag mit YouTube geschlossen.
        </p>
        <p>
          Auch für die Einbindung von YouTube verweisen wir auf die Zertifizierung von Google als sicherer
          Datenempfänger (s. Ziffer 2.3).
        </p>
        <p>
          Rechtsgrundlage für die Erhebung und weitere Verarbeitung der Informationen ist deine erteilte Einwilligung
          (Art. 6 Abs. 1 S. 1 lit. a DS-GVO). Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass davon
          die Zulässigkeit der Verarbeitung bis zum Widerruf berührt wird.
        </p>
        <p>
          Informationen zur Datenverarbeitung bei Nutzung von YouTube stellt Google
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://policies.google.com/privacy">hier</a>
          bereit.
        </p>
        <h3 id="google-tag-manager">Google Tag Manager</h3>
        <p>
          Wir verwenden in unseren digitalen Angeboten den Google Tag Manager, ein Tool von Google, das uns Website-Tags
          über eine Oberfläche verwalten lässt.
        </p>
        <p>
          Zweck unserer Nutzung dieses Tools ist es, JavaScript- und HTML-Tags für Tracking und Analysen mit eigener und
          Drittanbieter-Software zu verwalten. Tags sind kleine Code-Elemente, die uns anderem dabei helfen, Traffic und
          Besucherverhalten zu messen und unsere digitalen Angebote zu testen und zu optimieren. Der Google Tag Manager
          setzt (im leeren Zustand) keine eigenen Cookies und erfasst selbst keine personenbezogenen Daten. Er löst
          andere Tags aus, die wiederum ggf. personenbezogene Daten erfassen. Jedoch greift der Google Tags Manager
          selbst nicht auf diese Daten zu.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Google geschlossen. Die
          durch das Cookie erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine Benutzung
          dieser digitalen Angebote werden in der Regel an einen Server von Google in den USA übertragen und dort
          verarbeitet. Auch für die Einbindung des Google Tag Managers verweisen wir auf die Zertifizierung von Google
          als sicherer Datenempfänger (s. Ziffer 2.3).
        </p>
        <p>
          Auch für den Einsatz des Google Tag Managers holen wir deine Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DS-GVO)
          ein. Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass davon die Zulässigkeit der Verarbeitung
          bis zum Widerruf berührt wird.
        </p>
        <p>
          Informationen zur Nutzung des Google Tag Managers stellt Google in den
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://marketingplatform.google.com/about/analytics/tag-manager/use-policy/"
            >AGB</a
          >
          bereit, es gilt die
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://policies.google.com/privacy"
            >Datenschutzerklärung</a
          >
          von Google.
        </p>
        <h3 id="google-fonts">Google Fonts</h3>
        <p>
          Wir verwenden in unseren digitalen Angeboten sogenannte Google Fonts, also Schriftarten, die von Google
          bereitgestellt werden.
        </p>
        <p>
          Aufgrund von Google Fonts können wir die Schriftarten in unseren digitalen Angeboten einheitlich darstellen.
          Wenn du unsere Website besuchst, werden die Schriftarten (Fonts) direkt von den Servern von Google geladen.
          Dabei kann es zu einer Übertragung personenbezogener Daten (z. B. IP-Adressen) an Google kommen.
        </p>
        <p>
          Google agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Google geschlossen. Die
          durch das Cookie erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine Benutzung
          unserer digitalen Angebote werden in der Regel an einen Server von Google in den USA übertragen und dort
          verarbeitet. Auch für die Einbindung von Google Fonts verweisen wir auf die Zertifizierung von Google als
          sicherer Datenempfänger (s. Ziffer Ziffer 2.3).
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von Google Fonts und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst. Den Widerruf kannst du auch über das
          Browser-Add-on von Google durchführen, das über
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://tools.google.com/dlpage/gaoptout?hl=de/"
            >diesen Link</a
          >
          abrufbar ist.
        </p>
        <h3 id="microsoft-azure">Microsoft Azure</h3>
        <p>Wir verwenden in unseren digitalen Angeboten Microsoft Azure von Microsoft.</p>
        <p>
          Wir nutzen Azure zur sicheren und effizienten Bereitstellung unserer digitalen Angebote sowie zur Verarbeitung
          deiner Daten (z.B. IP-Adressen, Nutzerverhalten, Anmeldedaten und deinen Anfragen über unsere
          Kontaktformulare), um dir eine umfangreiche und interaktive Benutzererfahrung zu ermöglichen.
        </p>
        <p>
          Microsoft agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Microsoft geschlossen.
          Die Daten werden an einen Server von Microsoft innerhalb der EU übertragen und dort verarbeitet. Sofern Daten
          von Microsoft auf einen Server in den USA übertragen werden sollten, gilt folgendes: Microsoft hat sich als
          sicherer Datenempfänger, der die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt,
          zertifiziert. Bei einer Übertragung von Daten durch Microsoft wird also ein Datenschutzstandard gewahrt, der
          dem der DS-GVO entspricht. Wir haben zudem sog. Standardvertragsklauseln mit Microsoft vereinbart, deren Zweck
          die Einhaltung eines angemessenen Datenschutzniveaus im Drittland ist.
        </p>
        <p>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt im
          sicheren, stabilen und leistungsfähigen Betrieb unserer digitalen Angebote. Sofern eine Einwilligung (z. B.
          für bestimmte Tracking-Technologien über Azure-Dienste) erforderlich ist, erfolgt die Verarbeitung auf
          Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass
          davon die Zulässigkeit der Verarbeitung bis zum Widerruf berührt wird. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten oder im Microsoft Trust Center anpasst.
        </p>
        <p>
          Generelle Hinweise zur Datenverarbeitung durch Microsoft erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://privacy.microsoft.com/de-de/privacystatement"
            >Datenschutzerklärung</a
          >
          von Microsoft. Mehr zum Schutz der Azure-Kundendaten findest du
          <a
            href="https://learn.microsoft.com/de-de/azure/security/fundamentals/protection-customer-data?toc=%2Fcompliance%2Fassurance%2Ftoc.json&amp;bc=%2Fcompliance%2Fassurance%2Fbreadcrumb%2Ftoc.json"
            >hier</a
          >
          und
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://azure.microsoft.com/de-de/explore/trusted-cloud/privacy"
            >hier</a
          >.
        </p>
        <h3 id="microsoft-advertising">Microsoft Advertising</h3>
        <p>
          Zum Zwecke des Online-Marketings nutzen wir die Dienste und Funktionen von Microsoft Advertising, einem Dienst
          von Microsoft.
        </p>
        <p>
          Wir nutzen Microsoft Advertising als Werbetool, das es uns ermöglicht, unseren Nutzern zielgerichtete und
          personalisierte Werbung u. a. in den Suchmaschine Bing, DuckDuckGo und bei Yahoo anzuzeigen. Hierbei setzen
          wir Cookies und ähnliche Technologien ein, die das Nutzerverhalten analysieren und die Nutzer in unseren
          digitalen Angeboten wiedererkennen. Durch den Einsatz von Microsoft Advertising können wir unsere
          Werbemaßnahmen effektiver gestalten und deine Nutzererfahrung verbessern.
        </p>
        <p>
          Die durch diese Technologien gesammelten Informationen helfen uns, die Relevanz der von uns ausgespielten
          Werbung zu optimieren. Microsoft Advertising ermöglicht uns außerdem Werbung basierend auf
          Nutzerverhaltensprofilen und geografischem Standort gezielt auszuspielen. In diesem Zusammenhang übermitteln
          wir deine IP-Adresse und Informationen über dein verwendetes Endgerät (z. B. Gerätetyp, Betriebssystem,
          Browsertyp) an den Betreiber von Microsoft Advertising die Microsoft Corporation.
        </p>
        <p>
          Microsoft agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Microsoft geschlossen.
          Für die Einbindung von Microsoft Advertising verweisen wir auf die Zertifizierung von Microsoft als sicherer
          Datenempfänger (s. Ziffer 2.8).
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer Website und Zustimmung zu den entsprechenden Cookies
          gegeben hast. Du kannst deine Einwilligung zur Verwendung von Microsoft Advertising und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst oder über die Microsoft Advertising-Einstellungen
          die Personalisierung der Werbung deaktivierst.
        </p>
        <p>
          Generelle Hinweise zur Datenverarbeitung durch Microsoft erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://privacy.microsoft.com/de-de/privacystatement"
            >Datenschutzerklärung</a
          >
          von Microsoft.
        </p>
        <h3 id="microsoft-application-insights">Microsoft Application Insights</h3>
        <p>
          Zur Optimierung der Leistung, der Zuverlässigkeit und der Qualität unserer digitalen Angebote nutzen wir
          Microsoft Application Insights, ein Dienst von Microsoft.
        </p>
        <p>
          Hierzu erfasst und analysiert der Dienst Anwendungsdaten wie Benutzerinteraktionen, Fehler- und Problemquellen
          und Leistungsmetriken. Der Dienst gibt uns beispielsweise eine Übersicht über die Interaktion der
          Anwendungskomponenten und eine Möglichkeit in Echtzeit die Aktivitäten unserer digitalen Angebote zu sehen.
        </p>
        <p>
          Der Dienst sammelt hierfür Telemetriedaten der genutzten Anwendungen. Diese Daten sind anonyme statistische
          Daten. Die Herstellung eines Personenbezugs ist aufgrund dieser Daten nicht möglich. Deine für den Dienst
          erhobene IP-Adresse wird verkürzt und anonymisiert.
        </p>
        <p>
          Microsoft agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Microsoft geschlossen.
          Für die Einbindung der Microsoft Application Insights verweisen wir auf die Zertifizierung von Microsoft als
          sicherer Datenempfänger (s. Ziffer 2.8).
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer Website und Zustimmung zu den entsprechenden Cookies
          gegeben hast. Du kannst deine Einwilligung zur Verwendung von Google Ads und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst oder über die Microsoft Advertising-Einstellungen
          die Personalisierung der Werbung deaktivierst.
        </p>
        <p>
          Generelle Hinweise zur Datenverarbeitung durch Microsoft erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://privacy.microsoft.com/de-de/privacystatement"
            >Datenschutzerklärung</a
          >
          von Microsoft. Weitere Informationen zur Datenverarbeitung durch Microsoft erhältst du
          <a
            href="https://eu-central-1.protection.sophos.com/?d=microsoft.com&amp;u=aHR0cHM6Ly9sZWFybi5taWNyb3NvZnQuY29tL2RlLWRlL2F6dXJlL2F6dXJlLW1vbml0b3IvYXBwL2RhdGEtcmV0ZW50aW9uLXByaXZhY3k=&amp;i=NjIzOWNjNmNjOTIwOTUxMTMzOGJmNTYz&amp;t=dW5sT2EwYmNKNFdGc1JBNEMwQWQ4SHRDMDhPS0c1L1lqTHZteFVUNjEwaz0=&amp;h=dd4f1a1d5cd54505ad43574ae4828517&amp;s=AVNPUEhUT0NFTkNSWVBUSVafW8D7KLbh_QWX9Tt0WCpirmmXNmg5XzygYRCYuKLAKA"
            >hier</a
          >.
        </p>
        <h3 id="amazon-aws">Amazon AWS</h3>
        <p>
          Wir nutzen die Infrastruktur von Amazon Web Services („<strong>AWS</strong>“) des Anbieters Amazon Web
          Services EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxemburg („<strong>Amazon</strong>“). AWS ist ein
          Cloud-Computing-Anbieter, der uns Speicherplatz, Datenbanken, Netzwerke und andere Infrastruktur-Dienste zur
          Verfügung stellt, die für den Betrieb unserer digitalen Angebote erforderlich sind.
        </p>
        <p>
          Amazon agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Amazon geschlossen. Dabei
          werden personenbezogene Daten, die im Rahmen der Nutzung unserer digitalen Angebote verarbeitet werden, auf
          Servern von AWS gespeichert und verarbeitet. Diese Server befinden sich in Rechenzentren innerhalb der
          Europäischen Union, sofern technisch möglich und vertraglich vereinbart. Ausnahmsweise kann eine Verarbeitung
          in den USA erfolgen. Amazon hat sich als sicherer Datenempfänger, der die Datenschutzgrundsätze des Data
          Privacy Framework berücksichtigt, zertifiziert. Bei einer Übertragung von Daten in die USA durch Amazon wird
          also ein Datenschutzstandard gewahrt, der dem der DS-GVO entspricht. Wir haben zudem sog.
          Standardvertragsklauseln mit Amazon vereinbart, deren Zweck die Einhaltung eines angemessenen
          Datenschutzniveaus im Drittland ist
        </p>
        <p>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt im
          sicheren, stabilen und leistungsfähigen Betrieb unserer digitalen Angebote. Sofern eine Einwilligung (z. B.
          für bestimmte Tracking-Technologien über AWS-Dienste) erforderlich ist, erfolgt die Verarbeitung auf Grundlage
          von Art. 6 Abs. 1 lit. a DSGVO. Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass davon die
          Zulässigkeit der Verarbeitung bis zum Widerruf berührt wird. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Mehr Informationen zur Datenverarbeitung durch AWS findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://aws.amazon.com/de/compliance/gdpr-center/"
            >hier</a
          >
          sowie in der Datenschutzerklärung von Amazon
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://aws.amazon.com/de/privacy/">hier</a>.
        </p>
        <h3 id="clarity">Clarity</h3>
        <p>
          Wir nutzen in unseren digitalen Angeboten Dienste und Funktionen von Clarity, die von Microsoft angeboten
          werden.
        </p>
        <p>
          Clarity hilft uns festzustellen, wie unsere digitalen Angebote genutzt werden. Im Rahmen der Analyse erfahren
          wir, wie du u. a. mit der Maus auf agierst und wie lange du dir einen Inhalt in unseren digitalen Angeboten
          anschaust. Anhand dieser Informationen kann Clarity sogenannte Heatmaps erstellen. Die Heatmaps zeigen uns,
          welche Teile unserer digitalen Angebote von Besuchern am häufigsten aufgerufen werden. Des Weiteren kann
          Clarity Sitzungen von Besuchern der digitalen Angebote aufzeichnen, sodass wir die Seitennutzung in Form von
          Videos ansehen können. Hierdurch können wir unsere Onlinepräsenz und unsere Angebote für dich optimieren.
        </p>
        <p>
          Hierbei verwendet Clarity Technologien (z. B. Cookies oder Fingerprinting-Systeme), um Besucher
          wiederzuerkennen, wenn sie die digitalen Angebote erneut besuchen. Clarity agiert als Auftragsverarbeiter und
          wir haben einen entsprechenden Vertrag mit Clarity geschlossen. Die Informationen, die Clarity darüber
          sammelt, wie du diese digitalen Angebote nutzt, werden auf Servern von Microsoft (Microsoft Azure Cloud
          Service) in den USA gespeichert. Für die Einbindung von Clarity verweisen wir auf die Zertifizierung von
          Microsoft als sicherer Datenempfänger (s. Ziffer 2.8).
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von Clarity und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst oder über die Clarity-Einstellungen die
          Verarbeitung deaktivierst.
        </p>
        <p>
          Generelle Hinweise zur Datenverarbeitung durch Microsoft erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://privacy.microsoft.com/de-de/privacystatement"
            >Datenschutzerklärung</a
          >von Microsoft.
        </p>
        <h3 id="elfsight">Elfsight</h3>
        <p>
          Wir verwenden in unseren digitalen Angeboten die Dienste und Funktionen von Elfsight, einem Dienst der
          Elfsight, LLC., 0015, Armenia, Yerevan, Paronyana str., 19/3, 201 („Elfsight“).
        </p>
        <p>
          Elfsight ermöglicht es uns, Inhalte wie Bewertungen direkt von Google zu beziehen und in unseren digitalen
          Angeboten darzustellen. Dafür wird in der Regel deine IP-Adresse, Informationen über dein Betriebssystem und
          den verwendeten Browsertyp an Elfsight, übermittelt.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von Elfsight und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Generelle Hinweise zur Datenverarbeitung durch Elfsight erhältst du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://elfsight.com/privacy-policy/"
            >Datenschutzerklärung</a
          >
          von Elfsight.
        </p>
        <h3 id="linkedin-insight-tag">LinkedIn Insight Tag</h3>
        <p>
          Wir verwenden den LinkedIn Insight Tag, einen Webtracking-Dienst der LinkedIn Corporation, 2029 Stierlin
          Court, Mountain View, CA, 90403, USA. Innerhalb des Europäischen Wirtschaftsraums (EWR) und der Schweiz wird
          der Dienst von der LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Ireland („LinkedIn“) angeboten.
        </p>
        <p>
          Wir nutzen den LinkedIn Insight Tag, um von LinkedIn einen zusammenfassenden Bericht über die Demographie der
          Besucher unserer digitalen Angebote zu erhalten, etwa zu Branche, Jobbezeichnung, Unternehmensgröße,
          Karrierestufe und Standort unserer Websitebesucher. LinkedIn teilt uns dabei keine personenbezogenen Daten
          mit, sondern es erfolgt eine pseudonymisierte Verknüpfung der Daten, was bedeutet, dass LinkedIn die erhobenen
          Informationen nicht direkt einer bestimmten Person zuordnen kann, es sei denn, du bist bei LinkedIn
          eingeloggt. Auf Grundlage dieser Daten ist es uns möglich, Informationen zu unserer Zielgruppe zu erhalten,
          die Attraktivität unseres Angebots und insbesondere den Erfolg unserer Werbung zu messen.
        </p>
        <p>
          Im Rahmen der Nutzung des LinkedIn Insight Tag erhebt und verarbeitet LinkedIn verschiedene Daten, darunter
          deine IP-Adresse, Informationen über das verwendete Endgerät (z. B. Gerätetyp, Betriebssystem), Informationen
          zu Ihrem Browser und Surfverhalten, URL und Referrer-URL. LinkedIn anonymisiert die Daten vor Bereitstellung
          des entsprechenden Berichts an uns (spätestens binnen sieben Tagen) und löscht die Daten innerhalb von 180
          Tagen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO. Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass davon die Zulässigkeit
          der Verarbeitung bis zum Widerruf berührt wird. Du kannst die Einwilligung widerrufen, indem du deine
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst oder über die Werbeeinstellungen deines
          LinkedIn-Kontos änderst.
        </p>
        <p>
          Dadurch, dass wir den LinkedIn Insight Tag zur Optimierung unseres Online-Service und unserer
          Marketingmaßnahmen verwenden, haben wir auch ein berechtigtes Interesse i. S. d. Art. 6 Abs. 1 S. 1 lit. f
          DS-GVO. Gleichwohl wird der LinkedIn Insight Tag nur eingesetzt, wenn du eine Einwilligung erteilt hast.
        </p>
        <p>
          LinkedIn verarbeitet deine personenbezogenen Daten wie deinen Beruf, Daten zum Beschäftigungsstatuts, Land,
          Dienstalter und Unternehmensgröße, um uns Statistiken über personenbezogene Daten mit Filter- bzw.
          Einstellungsmöglichkeiten zur Verfügung zu stellen. Durch diese Daten können wir Statistiken beispielsweise
          über die Interessen oder die berufliche Situation unserer Nutzer erstellen lassen. Wir und LinkedIn sind dann
          gemeinsame Verantwortliche im Sinne des Art. 26 DS-GVO. Über die gemeinsame Verantwortlichkeit haben wir mit
          dem jeweiligen Partner einen Vertrag geschlossen. Es gelten ebenfalls die Datenschutzinformationen des
          jeweiligen Partners. Weitere Informationen zum LinkedIn Insight Tag bekommst du
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.linkedin.com/help/linkedin/answer/a427660"
            >hier</a
          >. Bei weiteren Fragen zur Datenverarbeitung durch LinkedIn, wende dich bitte direkt an LinkedIn.
        </p>
        <p>
          Die Daten werden an einen Server von LinkedIn übertragen und dort verarbeitet. LinkedIn hat sich als sicherer
          Datenempfänger, der die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt, zertifiziert. Bei
          einer Übertragung von Daten durch LinkedIn wird also ein Datenschutzstandard gewahrt, der dem der DS-GVO
          entspricht. Wir haben zudem sog. Standardvertragsklauseln mit LinkedIn vereinbart, deren Zweck die Einhaltung
          eines angemessenen Datenschutzniveaus im Drittland ist. Mehr Informationen zu den Standardvertragsklauseln
          findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://de.linkedin.com/legal/l/dpa">hier</a> oder
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://www.linkedin.com/legal/l/eu-sccs">hier</a
          >.
        </p>
        <p>
          Die Datenschutzbestimmungen von LinkedIn findest du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://www.linkedin.com/legal/privacy-policy"
            >Datenschutzerklärung</a
          >.
        </p>
        <h3 id="meta-pixel">Meta Pixel</h3>
        <p>
          Wir verwenden Meta Pixel, einen Webtracking-Dienst von Meta Platforms, Inc., Menlo Park, USA. Innerhalb des
          Europäischen Wirtschaftsraums (EWR) und der Schweiz wird der Dienst von Meta Platforms Ireland Limited, 4
          Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland („Meta“) angeboten.
        </p>
        <p>
          Wir nutzen Meta Pixel, um das Nutzerverhalten in unseren digitalen Angeboten besser zu verstehen und unsere
          Marketingkampagnen auf Plattformen wie Facebook und Instagram zu optimieren. Meta Pixel ermöglicht es uns,
          Berichte über Aktivitäten in unseren digitalen Angeboten zu erstellen, Conversions zu messen und gezielte
          Werbeanzeigen zu schalten. Dadurch können wir unsere Online-Präsenz und Werbeeffizienz kontinuierlich
          verbessern.
        </p>
        <p>
          Im Rahmen der Nutzung von Meta Pixel erhebt und verarbeitet Meta verschiedene Daten, darunter deine
          IP-Adresse, Informationen über das verwendete Endgerät (z. B. Gerätetyp, Betriebssystem, Browsertyp),
          Informationen zu deinem Surfverhalten (z. B. besuchte Seiten, Verweildauer, Klickverhalten), Standortdaten und
          eindeutige Kennungen, wie Cookie-IDs oder Facebook-IDs. Diese Daten werden verwendet, um Berichte über die
          Aktivitäten in unseren digitalen Angeboten zu erstellen, gezielte Werbung zu schalten und uns eine
          detaillierte Analyse des Nutzerverhaltens zu ermöglichen.
        </p>
        <p>
          Meta agiert als Auftragsverarbeiter, und wir haben einen entsprechenden Vertrag mit Meta geschlossen. Die
          durch das Cookie erzeugten Informationen und die IP-Adressen über deine Benutzung der digitalen Angebote
          werden in der Regel an einen Server von Meta in den USA übertragen und dort verarbeitet. Meta hat sich als
          sicherer Datenempfänger zertifiziert, indem es die Datenschutzgrundsätze des EU-U.S. Data Privacy Framework
          berücksichtigt. Dies bedeutet, dass ein Datenschutzstandard gewahrt wird, der dem der DS-GVO entspricht. Zudem
          haben wir sog. Standardvertragsklauseln mit Meta vereinbart, deren Zweck die Einhaltung eines angemessenen
          Datenschutzniveaus im Drittland ist.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO. Der Widerruf deiner Einwilligung ist jederzeit möglich, ohne dass davon die Zulässigkeit
          der Verarbeitung bis zum Widerruf berührt wird. Dies kannst du tun, indem du deine Cookie-Einstellungen in
          unseren digitalen Angeboten anpasst oder über die Werbeeinstellungen deines Meta-Kontos die Personalisierung
          der Werbung deaktivierst.
        </p>
        <p>
          Nähere Informationen zum Leistungsumfang von Meta Pixel erhältst du im
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.facebook.com/business/help/651294705016616"
            >Meta Business Help Center</a
          >. Informationen zur Datenverarbeitung stellt Meta
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://www.facebook.com/policy.php">hier</a>
          bereit.
        </p>
        <h3 id="hubspot-pixel-analytics-cdn-chat-cookie-banner-forms-leadflow-">
          HubSpot (Pixel, Analytics, CDN, Chat, Cookie Banner, Forms, LeadFlow)
        </h3>
        <p>
          Wir verwenden im Rahmen unserer digitalen Angebote die im Folgenden angeführten Dienste von HubSpot. Der
          Anbieter dieser Dienste ist HubSpot Inc. 25 First Street, Cambridge, Massachusetts 02141 USA („HubSpot“).
        </p>
        <p>HubSpot Pixel</p>
        <p>
          Wir verwenden HubSpot Pixel, um Besuchergruppen unserer digitalen Angebote aufzuteilen („Custom Audiences“),
          die Conversion-Rate zu bestimmen und zu optimieren. Die Conversion Rate zeigt uns das Verhältnis zwischen
          Anzahl der Besucher des digitalen Angebotes zur Anzahl einer gewünschten Handlung auf. HubSpot Pixel wird vor
          allem dann verwendet, wenn du mit unseren Werbeanzeigen interagierst, die wir in Zusammenarbeit mit HubSpot
          geschaltet haben.
        </p>
        <p>HubSpot Analytics</p>
        <p>
          In unseren digitalen Angeboten setzen wir die Analysefunktion HubSpot Analytics ein, um die Nutzung unserer
          digitalen Angebote statistisch auswerten zu können. Im Rahmen dieser Auswertung möchten wir insbesondere die
          Gesamtzahl der Besucher, die aufgerufenen Unterseiten und die jeweilige Verweildauer unserer Besucher
          erfahren. Für diese Auswertungen setzt HubSpot Analytics Technologien wie Cookies ein, die das Wiedererkennen
          von Nutzern und die Analyse ihres Verhaltens ermöglichen. Die so erhaltenen Informationen dienen dazu, die
          Aktivitäten in unseren digitalen Angeboten umfassend darzustellen.
        </p>
        <p>HubSpot CDN</p>
        <p>
          Wir verwenden auf in unseren digitalen Angeboten die Funktionen von HubSpot CDN als Content Delivery Network.
          Dieses Netzwerk ermöglicht das Laden unserer digitalen Angebote insbesondere für datenintensive Anwendungen zu
          beschleunigen und Inhalte sicher für dich bereitzustellen. Deine Daten werden insbesondere dazu genutzt,
          Inhalte wie Grafiken oder Scripts mit Hilfe von regional oder international verteilten Servern schneller
          bereitzustellen und die Sicherheit und Funktionsfähigkeit von HubSpot CDN zu gewährleisten.
        </p>
        <p>HubSpot Chat</p>
        <p>
          Wir verwenden in unseren digitalen Angeboten zudem auch Funktionen des HubSpot Chats, einer
          Kundenkommunikationsplattform. Dieser Dienst ermöglicht es uns mit unseren Kunden in Kontakt zu treten und
          über den Chat zu kommunizieren. So können wir gezielt bei deinen Fragestellungen Hilfe leisten. HubSpot Chat
          nutzt Cookies und weitere Browser-Technologien, um Nutzerverhalten auszuwerten und unsere Nutzer
          wiederzuerkennen. Des Weiteren wird HubSpot Chat verwendet, um in Chats eingegebene Daten mittels Cookies zu
          speichern und zu übertragen, samt deiner IP-Adresse.
        </p>
        <p>HubSpot Cookie Banner</p>
        <p>
          Den HubSpot Cookie Banner verwenden wir als Zustimmungslösung zur Einholung der Einwilligung von Nutzern zur
          Datenverarbeitung. So kannst du im Rahmen der Nutzung Cookies gezielt annehmen oder ablehnen. Des Weiteren
          dokumentiert der Cookie Banner deine Einwilligungen. HubSpot Cookie Banner nutzt Cookies oder andere
          Web-Technologien, um Nutzer wiederzuerkennen und die erteilte oder widerrufene Einwilligung zu speichern.
        </p>
        <p>HubSpot Forms</p>
        <p>
          HubSpot Forms ist ein Formulardesigner, um benutzerdefinierte Formulare für unsere Website [und unsere
          Plattform] zu erstellen. Mithilfe der Formulare sammeln wir wichtige Informationen über dich. Wenn du ein
          Formular ausfüllst, ermöglicht HubSpot Forms uns, dass du automatisch in unsere Datenbank aufgenommen wirst.
          So können wir deine Kontaktanfrage effizient bearbeiten und dich mit personalisierten Emails und Newslettern
          weiter ansprechen.
        </p>
        <p>HubSpot LeadFlow</p>
        <p>
          HubSpot LeadFlow verwenden wir zur Identifikation und Sammlung von Informationen potenzieller Kunden. Zudem
          hilft uns HubSpot LeadFlow Einblicke in den Besuchsverlauf zu bekommen.
        </p>
        <p>
          HubSpot LeadFlow nutzt Cookies und weitere Browser-Technologien, um Nutzerverhalten auszuwerten und Nutzer
          wiederzuerkennen. HubSpot LeadFlow sammelt und verarbeitet Daten über Unternehmen wie beispielsweise
          Unternehmensname, Telefonnummer, Adresse, Web-Adresse, Industrie, Unternehmensprofil und Umsatz.
        </p>
        <p>
          HubSpot agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit HubSpot geschlossen.
          Nähere Informationen hierzu findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://legal.hubspot.com/dpa">hier</a>. Teilweise
          werden von HubSpot erfasste Daten an Server von HubSpot in die USA zu übertragen. HubSpot hat sich als
          sicherer Datenempfänger zertifiziert, der die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt.
          Bei einer Übertragung von Daten in die USA durch HubSpot wird also ein Datenschutzstandard gewahrt, der dem
          der DS-GVO entspricht. Wir haben zudem sog. Standardvertragsklauseln mit HubSpot vereinbart, deren Zweck die
          Einhaltung eines angemessenen Datenschutzniveaus im Drittland ist. Nähere Informationen findest du
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.hubspot.de/data-privacy/privacy-shield"
            >hier</a
          >.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten durch die Dienste von HubSpot ist nach den jeweiligen Diensten
          zu differenzieren.
        </p>
        <p>
          Die Verarbeitung deiner Daten durch die Dienste Pixel, Analytics, Chat und LeadFlow erfolgt auf Grundlage
          deiner Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a DS-GVO. Der Widerruf deiner Einwilligung ist jederzeit
          möglich, ohne dass davon die Zulässigkeit der Verarbeitung bis zum Widerruf berührt wird. Dies kannst du tun,
          indem du deine Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Die Verarbeitung deiner Daten durch den Dienst HubSpot CDN erfolgt aufgrund unseres berechtigten Interesses an
          einer möglichst fehlerfreien, sicheren und effizienten Bereitstellung unserer digitalen Angebote und der damit
          zusammenhängenden Inhalten (Art. 6 Abs. 1 S. 1 lit. f DS-GVO).
        </p>
        <p>
          Rechtsgrundlage für die effiziente Verarbeitung deiner personenbezogenen Daten in Form deiner Kontaktanfrage
          durch den Dienst HubSpot Forms ist Art. 6 Abs. 1 S. 1 lit. b DS-GVO. Dadurch, dass deine Daten ausschließlich
          zweckgebunden zur Beantwortung und Bearbeitung nur aus dem Anlass deiner Frage genutzt werden, haben wir auch
          ein berechtigtes Interesse i. S. d. Art. 6 Abs. 1 S. 1 lit. f DS-GVO. Wir wollen dir eine schnelle, sichere
          und unkomplizierte Kontaktaufnahme ermöglichen.
        </p>
        <p>
          Die Rechtsgrundlage für die Verarbeitung deiner personenbezogenen Daten durch den Dienst HubSpot Cookie-Banner
          ist wiederrum Art. 6 Abs. 1 S. 1 lit. c DS-GVO, da der Cookie-Banner zur Erfüllung der gesetzlichen
          Verpflichtungen einer Einwilligung i. S. d. Art. 6 Abs. 1 S. 1 lit. a DS-GVO i. V. m. Art. 7 DS-GVO
          erforderlich ist.
        </p>
        <p>
          Details zum Umgang von HubSpot mit Daten findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://legal.hubspot.com/de/privacy-policy"
            >hier</a
          >.
        </p>
        <h3 id="jsdelivr-cdn">JSDelivr CDN</h3>
        <p>
          Wir verwenden in unseren digitalen Angeboten JSDelivr CDN als Content Delivery Network. JSDelivr CDN ist ein
          Produkt von ProspectOne, Królewska 65A/1,30-081, Kraków, Polen. Deine Daten werden insbesondere dazu genutzt,
          Inhalte wie Grafiken oder Scripts mit Hilfe von regional oder international verteilten Servern schneller
          bereitzustellen und die Sicherheit und Funktionsfähigkeit des JSDelivr CDN zu gewährleisten.
        </p>
        <p>
          Dieses Netzwerk ermöglicht das Laden unserer digitalen Angebote insbesondere für datenintensive Anwendungen zu
          beschleunigen, sodass wir auch große Lastenspitzen ausgleichen können und den Download von
          JavaScript-Bibliotheken sowie von auf npm- und GitHub-Servern gehosteten Dateien. Darüber hinaus können auch
          WordPress-Plugins geladen werden, sofern diese über WordPress.org bereitgestellt werden. Hierfür schickt dein
          Browser personenbezogene Daten wie deine IP-Adresse, dein Browsertyp, die Browserversion und die von dir
          aufgerufenen Seiten an die Server von JSDelivr.
        </p>
        <p>
          Die Verarbeitung deiner Daten durch das JSDelivr CDN erfolgt aufgrund unseres berechtigten Interesses an einer
          möglichst fehlerfreien, sicheren und effizienten Bereitstellung unserer digitalen Angebote und der damit
          zusammenhängenden Inhalten sowie der Optimierung unserer digitalen Angebote (Art. 6 Abs. 1 S. 1 lit. f
          DS-GVO).
        </p>
        <p>
          Prospect One agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit ProspectOne
          geschlossen. Die durch das/die Cookie/s erzeugten Informationen können auch auf Server außerhalb des
          Europäischen Wirtschaftsraums übermittelt werden. Bezüglich einer Datenübermittlung an einen Server von
          ProspectOne in den USA (und anschließender Verarbeitung) hat sich ProspectOne als sicherer Datenempfänger, der
          die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt, zertifiziert. Bei einer Übertragung von
          Daten in die USA durch ProspectOne wird also ein Datenschutzstandard gewahrt, der dem der DS-GVO entspricht.
          Wir haben zudem sog. Standardvertragsklauseln mit ProspectOne vereinbart, deren Zweck die Einhaltung eines
          angemessenen Datenschutzniveaus in anderen Drittländern ist.
        </p>
        <p>
          Nähere Informationen erhältst du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.jsdelivr.com/privacy-policy-jsdelivr-net/"
            >Datenschutzerklärung</a
          >.
        </p>
        <h3 id="outbrain">Outbrain</h3>
        <p>
          Wir verwenden Outbrain, einen Dienst von Outbrain Inc., 111 West 19th Street, 3rd Foor, New York, NY 10011,
          USA („Outbrain“).
        </p>
        <p>
          Wir nutzen Outbrain, um das Nutzerverhalten auf unserer Website besser zu verstehen und um für unsere Inhalte
          sowie Dienstleistungen zielgerichtet Werbung auf Grundlage von Verhaltensprofilen und geografischer Lage.
        </p>
        <p>
          Im Rahmen der Nutzung von Outbrain erhebt und verarbeitet Outbrain deine IP-Adresse, Informationen über das
          verwendete Endgerät (z. B. Gerätetyp, Betriebssystem, Browsertyp), Informationen zu deinem Surfverhalten (z.
          B. besuchte Seiten, Verweildauer, Klickverhalten), Standortdaten und eindeutige Kennungen, die vereisenden
          URLs und andere normalerweise bei HTTP-Anfragen übertragenen Informationen (z. B. Informationen, die uns
          mitteilen, wie du i auf unsere digitalen Angebote gelangt bist).
        </p>
        <p>
          Outbrain agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Outbrain geschlossen.
          Die erzeugten Informationen und die (in der Regel gekürzten) IP-Adressen über deine Benutzung dieser digitalen
          Angebote werden in der Regel an einen Server von Outbrain in den USA übertragen und dort verarbeitet. Outbrain
          hat sich als sicherer Datenempfänger, der die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt,
          zertifiziert. Bei einer Übertragung von Daten in die USA durch Outbrain wird also ein Datenschutzstandard
          gewahrt, der dem der DS-GVO entspricht. Wir haben zudem sog. Standardvertragsklauseln mit Outbrain vereinbart,
          deren Zweck die Einhaltung eines angemessenen Datenschutzniveaus im Drittland ist.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von Outbrain und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a
            href="https://www.outbrain.com/privacy/wp-content/uploads/2022/02/Outbrain-Privacy-Policy-German-4-November-2021-1.pdf"
            >Datenschutzerklärung</a
          >
          von Outbrain.
        </p>
        <h3 id="crn-car-data-service">CRN Car Data Service</h3>
        <p>
          Wir verwenden CRN CarData Service, einen Dienst von carrepnet.ch ag, Therwilerstrasse 52, 4104 Oberwil,
          Schweiz („CRN“).
        </p>
        <p>Wir nutzen CRN CarData Service zur Verarbeitung von CRN-Reparaturauftragsdaten.</p>
        <p>
          Im Rahmen der Nutzung von CRN CarData Service erhebt und verarbeitet CRN in erster Linie Auftragsdaten. Zudem
          verarbeitet CRN gegebenenfalls im Rahmen des Auftrags personenbezogene und technische Daten wie deinen Namen,
          deine E-Mail-Adresse oder deine IP-Adresse. Darüber hinaus erhebt CRN – soweit rechtlich zulässig – Daten aus
          öffentlich zugänglichen Registern (z.B. Handelsregister, etc.). CRN agiert als Auftragsverarbeiter und wir
          haben einen entsprechenden Vertrag mit CRN geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von CRN und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://carrepnet.ch/index.php/impressum/"
            >Datenschutzerklärung</a
          >
          von CRN.
        </p>
        <h3 id="pdr">PDR</h3>
        <p>
          Wir verwenden PDR Service (PDR), einen Dienst der PDR.cloud GmbH, Attilastraße 16, 12529 Schönefeld,
          Deutschland („PDR“).
        </p>
        <p>Wir nutzen PDR Service zur Verarbeitung von PDR-Reparaturauftragsdaten.</p>
        <p>
          Im Rahmen der Nutzung von PDR Service erhebt und verarbeitet PDR in erster Linie Auftragsdaten. Zudem
          verarbeitet PDR gegebenenfalls personenbezogene und technische Daten wie deinen Namen, deine E-Mail-Adresse
          oder deine IP-Adresse. PDR agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit PDR
          geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von PDR und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://pdr.cloud/datenschutzerklaerung/"
            >Datenschutzerklärung</a
          >
          von PDR.
        </p>
        <h3 id="werbas-ksr">Werbas KSR</h3>
        <p>
          Wir verwenden Werbas KSR, einen Dienst der Werbas KSR GmbH, Max-Eyth-Strasse 42, 71088 Holzgerlingen,
          Deutschland („KSR“). Wir verwenden die Services KSR Service und KSR Identity.
        </p>
        <p>
          Wir nutzen KSR Service zur Verarbeitung von Reparaturauftragsdaten. Im Rahmen der Nutzung von KSR Service
          erhebt und verarbeitet KSR in erster Linie Auftragsdaten. Zudem verarbeitet KSR gegebenenfalls
          personenbezogene und technische Daten wie deinen Namen, deine E-Mail-Adresse oder deine IP-Adresse.
        </p>
        <p>
          KSR Identity nutzen wir zum Nachweis deiner Identität, bevor du Zugriff auf unsere digitalen Angebote
          bekommst. Dabei werden deine Daten verarbeitet, die für die Registrierung, Verwaltung und Authentifizierung
          von Nutzerkonten erforderlich sind. KSR agiert als Auftragsverarbeiter und wir haben einen entsprechenden
          Vertrag mit KSR geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten für KSR Service erfolgt auf Grundlage deiner Einwilligung
          gemäß Art. 6 Abs. 1 S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu
          den entsprechenden Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von KSR und der damit
          verbundenen Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Der Zweck der Verarbeitung deiner Daten für KSR Identity durch uns liegt in der Regel in der Durchführung des
          mit dir vereinbarten (für dich ggf. unentgeltlichen) Vertrags zur Nutzung unserer Plattform als Nutzer bzw.
          der Bereitstellung eines von dir angefragten Services. Die Rechtsgrundlage für die Erhebung und Verarbeitung
          durch KSR ist dann Art. 6 Abs. 1 S. 1 lit. b DS-GVO.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://werbas-ksr.com/datenschutz/"
            >Datenschutzerklärung</a
          >
          von KSR.
        </p>
        <h3 id="da">DA</h3>
        <p>
          Wir verwenden DA Service, einen Dienst der DA / Software Solutions GmbH, Huestraße 19-25, 44787 Bochum,
          Deutschland („DA“).
        </p>
        <p>
          Wir nutzen den DA Service zur Verarbeitung von Reparaturauftragsdaten. Im Rahmen der Nutzung des DA Services
          erhebt und verarbeitet DA in erster Linie Auftragsdaten. Zudem verarbeitet DA gegebenenfalls personenbezogene
          und technische Daten wie deinen Namen, deine E-Mail-Adresse oder deine IP-Adresse. DA agiert als
          Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit DA geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von DA und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.digitalesautohaus.de/datenschutzerklaerung/"
            >Datenschutzerklärung</a
          >
          von DA.
        </p>
        <h3 id="gcs">GCS</h3>
        <p>
          Wir verwenden dem GCS Fahrzeugdaten Service, einen Dienst der GCS Schweiz AG, Therwilerstrasse 52, 4104
          Oberwil, Schweiz („GCS“).
        </p>
        <p>
          Wir nutzen den GCS Fahrzeugdaten Service als Fahrzeugdaten-API. Über diese Schnittstelle werden
          fahrzeugspezifische Daten (wie die Fahrzeug-ID, Marke, Modell, Baujahr) automatisiert abgerufen und
          verarbeitet. Die Nutzung erfolgt zur Identifikation und Bewertung von Fahrzeugen sowie zur Unterstützung
          nachgelagerter Prozesse wie der Schadensbearbeitung oder Reparaturkalkulation.
        </p>
        <p>
          Im Rahmen der Nutzung von GCS Fahrzeugdaten Service erhebt und verarbeitet GCS in erster Linie Fahrzeugdaten.
          Zudem verarbeitet GCS gegebenenfalls im Rahmen des Auftrags personenbezogene und technische Daten wie deinen
          Namen, deine E-Mail-Adresse oder deine IP-Adresse. Darüber hinaus erhebt GCS – soweit rechtlich zulässig –
          Daten aus öffentlich zugänglichen Registern (z.B. Handelsregister, etc.). GCS agiert als Auftragsverarbeiter
          und wir haben einen entsprechenden Vertrag mit GCS geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grundlage deiner Einwilligung gemäß Art. 6 Abs. 1
          S. 1 lit. a DS-GVO, die du durch die Nutzung unserer digitalen Angebote und Zustimmung zu den entsprechenden
          Cookies gegeben hast. Du kannst deine Einwilligung zur Verwendung von GCS und der damit verbundenen
          Datenerhebung jederzeit mit Wirkung für die Zukunft widerrufen. Dies kannst du tun, indem du die
          Cookie-Einstellungen in unseren digitalen Angeboten anpasst.
        </p>
        <p>
          Nähere Informationen findest du in der
          <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            href="https://www.gcsag.ch/datenschutz/__Datenschutz.html"
            >Datenschutzerklärung</a
          >
          von GCS.
        </p>
        <h3 id="deepsight">Deepsight</h3>
        <p>
          Wir verwenden den Deepsight Service, einen Dienst der deepsight GmbH, Albert-Einstein-Straße 1, 49076
          Osnabrück, Deutschland („Deepsight“).
        </p>
        <p>
          Wir nutzen den Deepsight Service als KI-basierten Bildverarbeitungsdienst. Der Service ist ein Dienst
          insbesondere zur automatisierten Anonymisierung von Bilddaten (Anonymisierungs-API). Die Anonymisierung
          erfolgt über eine technische Schnittstelle (API), die personenbezogenen Informationen automatisch erkennt und
          unkenntlich macht. Deepsight agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit
          Deepsight geschlossen.
        </p>
        <p>
          Der Zweck der Verarbeitung ist die Sicherstellung datenschutzkonformer Weiterverarbeitung bildbasierter
          Informationen und die Vorbereitung dieser Daten auf eine Archivierung, Analyse oder Weitergabe an Dritte.
          Deepsight agiert als Auftragsverarbeiter und wir haben einen entsprechenden Vertrag mit Deepsight geschlossen.
        </p>
        <p>
          Die Verarbeitung deiner personenbezogenen Daten erfolgt auf Grund unseres berechtigten Interesses an einer
          datenschutzkonformen Leistungserbringung (Art. 6 Abs. 1 S. 1 lit. f DS-GVO).
        </p>
        <p>
          Nähere Informationen findest du in der
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://deepsight.de/de/datenschutz/"
            >Datenschutzerklärung</a
          >
          von Deepsight.
        </p>
        <h3 id="zahlungsdienstleister-stripe">Zahlungsdienstleister Stripe</h3>
        <p>
          Für die Abwicklung einer Zahlung nutzen wir Stripe. Betreiber ist die Stripe, Inc., 510 Townsend Street, San
          Francisco, CA 94103, USA („Stripe“).
        </p>
        <p>
          Bei der Nutzung von Stripe erfolgt die Erhebung der Zahlungsinformationen direkt durch den
          Zahlungsdienstleister über ein in unseren Check-Out Prozess integriertes Eingabefeld. Wir übermitteln dann die
          von dir im Check-Out Prozess bereitgestellten persönlichen Daten und Zahlungsdaten (wie Kreditkartennummer,
          Bank, Währung, Transaktionsnummer) an Stripe. Teilweise überträgt Stripe dabei auch Daten in die USA. Stripe
          hat sich als sicherer Datenempfänger, der die Datenschutzgrundsätze des Data Privacy Framework berücksichtigt,
          zertifiziert. Bei einer Übertragung von Daten in die USA durch Stripe wird also ein Datenschutzstandard
          gewahrt, der dem der DS-GVO entspricht.
        </p>
        <p>
          Der Zweck der Verarbeitung dieser Daten liegt in der Durchführung der Zahlung im Rahmen eines mit dir
          vereinbarten Vertrags. Die Rechtsgrundlage für die Datenverarbeitung ist dann Art. 6 Abs. 1 S. 1 lit. b
          DS-GVO.
        </p>
        <p>
          Weitere Hinweise findest du
          <a target="_blank" rel="nofollow noopener noreferrer" href="https://stripe.com/de/privacy">hier</a> in der
          Datenschutzerklärung von Stripe.
        </p>
        <h2 id="nutzung-der-plattform-nutzeraccount">Nutzung der Plattform | Nutzeraccount</h2>
        <p>
          Entscheidest du dich dazu unsere Plattform zu verwenden, um einem unserer gewerblichen Partner deine Daten zu
          übermitteln, und legst du ggf. auch einen Nutzeraccount bei uns an, verarbeiten wir deine jeweils vor dir
          eingegebenen Daten (z. B. Kontaktdaten wie Name, Anschrift, E-Mail-Adresse, Telefonnummer und Daten über dein
          Kraftfahrzeug) neben unserem Partner auch für eigene Zwecke. Wir und der jeweilige Partner sind dann
          gemeinsame Verantwortliche im Sinne des Art. 26 DS-GVO. Mehr zur gemeinsamen Verarbeitung mit unserem Partner
          erfährst du in der folgenden Ziffer 5.
        </p>
        <p>
          Der Zweck der Verarbeitung deiner Daten durch uns liegt in der Regel in der Durchführung des mit dir
          vereinbarten (für dich unentgeltlichen) Vertrags zur Nutzung unserer Plattform als Nutzer bzw. der
          Bereitstellung eines von dir angefragten Services. Die Rechtsgrundlage für die Erhebung und weitere
          Verarbeitung ist dann Art. 6 Abs. 1 S. 1 lit. b DS-GVO.
        </p>
        <p>
          Möchtest du als registrierter Nutzer über unser digitales Angebot einen weiteren, anderen Partner kontaktieren
          als jenen, über den du ursprünglich auf unsere Plattform gelangt bist, so geben wir die von dir in deinem
          Nutzeraccount hinterlegten Daten hierzu auch an diesen Partner weiter. Die Weitergabe deiner Daten an einen
          weiteren Partner erfolgt ausschließlich auf deine Veranlassung und im Rahmen der Vertragserfüllung. Die
          Rechtsgrundlage für diese weitere Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. b DS-GVO.
        </p>
        <h2 id="gemeinsame-verantwortlichkeit-mit-unseren-partnern-als-nutzer-unserer-plattform-mit-nutzeraccount">
          Gemeinsame Verantwortlichkeit mit unseren Partnern als Nutzer unserer Plattform mit Nutzeraccount
        </h2>
        <p>
          Wenn du unsere Plattform (als Gastnutzer oder als registrierter Nutzer mit Nutzeraccount) nutzt und dabei
          Daten eingibst, verarbeiten wir diese Daten gemeinsam mit unserem Partner, dessen Leistung du über die
          Plattform beziehst, buchst oder anfragst. Wir sind dann gemeinsame Verantwortliche im Sinne des Art. 26 DSGVO.
          Wir haben einen Vertrag über die gemeinsame Verantwortlichkeit mit unseren Partnern geschlossen.
        </p>
        <p>
          Für die Datenverarbeitung durch uns gelten diese Datenschutzbestimmungen. Wie unser jeweiliger Partner deine
          Daten verarbeiten, erfährst du in der jeweiligen Datenschutzerklärung unseres Partners.
          <span v-if="partnerPrivacyUrl">
            Informationen zu unserem Partner {{ partner.companyName }}, dessen Leistung du aktuell über die Plattform
            beziehst, buchst oder anfragen kannst, findest du <a :href="partnerPrivacyUrl">hier</a>.
          </span>
        </p>
        <h2 id="sonstige-kontaktaufnahme">Sonstige Kontaktaufnahme</h2>
        <p>
          Falls du Informationen über uns und unsere Leistungen wünscht oder mit uns aus sonstigem Grund Kontakt
          aufnehmen möchten, kannst du uns jederzeit über unsere angegebenen Kontaktdaten kontaktieren. Wir verarbeiten
          die von dir mitgeteilten Informationen dann, um dein Anliegen zu bearbeiten und mir dir zu kommunizieren.
        </p>
        <p>
          Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DS-GVO oder, falls wir bereits in
          einem Vertragsverhältnis mit dir stehen oder die Kontaktaufnahme der Anbahnung eines solches
          Vertragsverhältnisses dient, Art. 6 Abs. 1 S. 1 lit. b DS-GVO.
        </p>
        <p>
          Du kannst der weiteren Verarbeitung deiner Daten jederzeit widersprechen, wenn du dies nicht mehr wünschst.
          Die Daten, die wir im Zusammenhang mit einer Bestellung von dir erheben, werden gelöscht, sobald der
          vereinbarte Vertrag bzw. die Bereitstellung eines von dir angefragten Services vollständig und abschließend
          bearbeitet ist und keine weitere Kommunikation oder Aufbewahrung von Daten erforderlich ist.
        </p>
        <h2 id="weitergabe-deiner-daten">Weitergabe deiner Daten</h2>
        <p>
          Wir geben deine Daten nur an Dritte weiter, wenn wir hierzu aufgrund deiner Einwilligung berechtigt oder
          aufgrund des geltenden Rechts berechtigt oder verpflichtet sind. Gleiches gilt, wenn wir deine Daten von
          Dritten, d. h. weder von euch noch von uns beauftragten Unternehmen, erhalten.
        </p>
        <p>
          Neben den in diesen Datenschutzhinweisen ausdrücklich genannten Dritten können gegebenenfalls auch externe
          Dienstleister für den Betrieb unserer digitalen Angebote im Rahmen von Auftragsverarbeitungsverträgen,
          Staatliche Stellen und Behörden, soweit dies zur Erfüllung einer gesetzlichen Verpflichtung erforderlich ist,
          oder zur Durchführung unseres Geschäftsbetriebs eingesetzte Personen (wie z. B. Auditoren, Rechtsberater,
          Versicherungen, Banken, Aufsichtsbehörden) Zugriff auf deine Daten erhalten. Soweit externe Dienstleister mit
          deinen personenbezogenen Daten in Berührung kommen, stellen wir durch rechtliche, technische und
          organisatorische Maßnahmen sicher, dass diese die Vorschriften der Datenschutzgesetze einhalten und – soweit
          sie als Auftragsverarbeiter tätig werden – deine Daten nur in unserem Auftrag und nach unseren Weisungen
          verarbeiten.
        </p>
        <p>
          Einige datenverarbeitende Drittgesellschaften können sich auch außerhalb des Europäischen Wirtschaftsraums
          (EWR), also in Drittländern, befinden. Eine derartige Verarbeitung erfolgt ausschließlich aufgrund deiner
          Einwilligung, zur Erfüllung der vertraglichen und geschäftlichen Verpflichtungen und zur Pflege deiner
          Geschäftsbeziehung zu uns (Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit a, lit. b oder lit. f jeweils i. V. m.
          Art. 44 ff. DS-GVO). Über die jeweiligen Einzelheiten der Weitergabe unterrichten wir dich an den dafür
          relevanten Stellen. Einigen Drittländern bescheinigt die Europäische Kommission durch sog.
          Angemessenheitsbeschlüsse einen Datenschutzstandard, der mit dem EWR-Standard vergleichbar ist (eine Liste
          dieser Länder sowie eine Kopie der Angemessenheitsbeschlüsse erhältst du
          <a
            href="https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en"
            >hier</a
          >).
        </p>
        <p>
          Unter anderem bescheinigt die Europäische Kommission den USA durch einen Angemessenheitsbeschluss, dass der im
          Data Privacy Framework vorgesehene Datenschutzstandard mit dem EWR-Standard vergleichbar ist. Bei einer
          Übertragung von Daten in die USA durch ein nach dem Data Privacy Framework zertifiziertes Unternehmen wird
          also ein Datenschutzstandard gewahrt, der dem der DS-GVO entspricht.
        </p>
        <h2 id="speicherdauer-und-l-schung-von-daten">Speicherdauer und Löschung von Daten</h2>
        <p>
          Falls oben nicht bereits ausdrücklich oder anders angegeben, werden die von uns erhobenen Daten gelöscht,
          sobald diese für den Zweck der Erhebung nicht mehr erforderlich sind.
        </p>
        <p>
          Kontaktformulardaten und andere Daten, die du uns im Rahmen einer sonstigen Kontaktaufnahme übermittelst,
          werden gelöscht, sobald der Zweck der Verarbeitung entfallen ist, d. h. beispielsweise dein Anliegen
          vollständig und abschließend bearbeitet und erledigt ist und keine weitere Kommunikation mit dir erforderlich
          oder von dir gewünscht ist.
        </p>
        <h2 id="deine-betroffenenrechte">Deine Betroffenenrechte</h2>
        <p>
          <strong>Recht auf Auskunft:</strong> Du hast das Recht, unter den Voraussetzungen des Art. 15 DS-GVO jederzeit
          unentgeltlich Einsicht in deine bei uns gespeicherten personenbezogenen Daten zu verlangen, wenn wir diese
          bearbeiten. So hast du die Möglichkeit, zu prüfen, welche personenbezogene Daten wir über dich bearbeiten, und
          dass wir diese gemäß geltenden Datenschutzbestimmungen verwenden.
        </p>
        <p>
          <strong>Recht auf Berichtigung:</strong> Du hast das Recht, unter den Voraussetzungen des Art. 16 DS-GVO
          unrichtige oder unvollständige personenbezogene Daten berichtigen zu lassen und über die Berichtigung
          informiert zu werden. Wir informieren in diesem Fall die Empfänger der betroffenen Daten über die
          vorgenommenen Anpassungen, sofern dies nicht für uns unmöglich oder mit unverhältnismäßigem Aufwand verbunden
          ist.
        </p>
        <p>
          <strong>Recht auf Löschung:</strong> Du hast das Recht, dass deine personenbezogenen Daten unter den
          Voraussetzungen des Art. 17 DS-GVO gelöscht werden. Im Einzelfall kann das Recht auf Löschung gemäß Art. 17
          Abs. 3 DS-GVO oder Art. 35 DS-GVO eingeschränkt oder ausgeschlossen sein.
        </p>
        <p>
          <strong>Recht auf Einschränkung der Bearbeitung:</strong> Du hast unter den Voraussetzungen des Art. 18 DS-GVO
          das Recht zu verlangen, dass die Bearbeitung deiner personenbezogenen Daten eingeschränkt wird.
        </p>
        <p>
          <strong>Recht auf Datenübertragung:</strong> Unter den Voraussetzungen des Art. 20 DS-GVO hast du das Recht,
          von uns die personenbezogenen Daten, welche du uns bereitgestellt hast, unentgeltlich in einem lesbaren Format
          zu erhalten. Dabei sind allerdings die Einschränkungen des Art. 20 Abs. 3 und 4 DS-GVO, § 28 BDSG sind zu
          berücksichtigen.
        </p>
        <p>
          <strong>Recht auf Widerruf:</strong> Du hast das Recht, eine gegebenenfalls erteilte datenschutzrechtliche
          Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit,
          der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
        </p>
        <h2 id="widerspruch">Widerspruch</h2>
        <p>
          Du kannst der Verarbeitung dich betreffender personenbezogener Daten durch uns aus Gründen, welche sich aus
          deiner besonderen Situation ergeben, jederzeit widersprechen, soweit wir diese Daten zur Wahrnehmung
          berechtigter Interessen (Art. 6 Abs. 1 S. 1 lit. f DS-GVO) verwenden. Im Fall des berechtigten Widerspruchs
          haben wir jede weitere Verarbeitung deiner Daten zu unterlassen, soweit sie nicht aus zwingenden
          schutzwürdigen Gründen, die deine Interessen, Rechte und Freiheiten überwiegen, oder zur Geltendmachung,
          Ausübung oder Verteidigung von Rechtsansprüchen notwendig ist.
        </p>
        <p>
          Soweit deine personenbezogenen Daten durch uns für Zwecke der Direktwerbung verarbeitet werden, hast du das
          recht, jederzeit uneingeschränkt Widerspruch gegen die Verarbeitung deiner Daten für derartige Werbezwecke
          einzulegen. In diesem Fall ist die Angabe einer besonderen Situation nicht erforderlich. Im Falle deines
          Widerspruchs wird die Verarbeitung für Zwecke der Direktwerbung umgehend eingestellt.
        </p>
        <p>Zum Zwecke des Widerspruchs kannst du formfrei die oben genannten Kontaktmöglichkeiten nutzen.</p>
        <h2 id="beschwerderecht">Beschwerderecht</h2>
        <p>
          Sofern du der Auffassung bist, dass die Verarbeitung der dich betreffenden personenbezogenen Daten durch uns
          gegen datenschutzrechtliche Bestimmungen verstößt, steht dir ein Recht auf Beschwerde bei einer
          Aufsichtsbehörde, insbesondere in dem Mitgliedstaat deines gewöhnlichen Aufenthaltsorts, deines Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes, nach Art. 77 DS-GVO zu.
        </p>
        <p>
          In Niedersachsen ist die
          <strong>Landesbeauftragte für Datenschutz und Informationsfreiheit Niedersachsen</strong> die zuständige
          Aufsichtsbehörde, die unter nachfolgenden Kontaktdaten zu erreichen ist:
        </p>
        <p>
          Landesbeauftragte für Datenschutz und Informationsfreiheit Niedersachsen<br />Prinzenstraße 5<br />30159
          Hannover
        </p>
        <p>Telefon: 0511/120-4500 Fax: 0511/120-4599 E-Mail: poststelle@lfd.niedersachsen.de</p>
        <h2 id="datensicherheit">Datensicherheit</h2>
        <p>
          Zur Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, werden deine Daten verschlüsselt
          übertragen. Wir sichern unsere Website und die sonstigen Systeme durch technische und organisatorische
          Maßnahmen, insbesondere die Verschlüsselungstechnologie TSL (Transport Layer Security), gegen Verlust,
          Zerstörung, Zugriff, Veränderung oder Verbreitung deiner Daten durch unbefugte Personen.
        </p>
        <p>
          Wir treffen unter Berücksichtigung des Stands der Technik, der Implementierungskosten und der Art, des
          Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der Eintrittswahrscheinlichkeit und Schwere der
          Verletzung von Rechten und Freiheiten natürlicher Personen angemessene technische und organisatorische
          Maßnahmen im Sinne von Art. 32 DS-GVO.
        </p>
      </v-card>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutSimple }
})
export default class Privacy extends Vue {
  get partner(): PartnerEntity {
    return ReportModule?.partner;
  }

  get companyName(): string {
    return this.partner?.companyName;
  }

  get street(): string {
    return this.partner?.address?.street || "";
  }

  get city(): string {
    return this.partner?.address?.city || "";
  }

  get zip(): string {
    return this.partner?.address?.zip || "";
  }

  get partnerPrivacyUrl() {
    return this.partner?.settings?.privacyUrl.link;
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
